var render = function render(){
  var _vm$targetDictionary$, _vm$correctionTargetD;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.open ? _c('div', {
    staticClass: "layer_pop_wrap"
  }, [_c('div', {
    staticClass: "layer_pop_dim",
    staticStyle: {
      "display": "block",
      "z-index": "1001"
    }
  }), _c('div', {
    staticClass: "layer_pop editor lg active",
    attrs: {
      "data-role-popup": "modal_01",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "pop_head"
  }, [_c('h2', [_vm._v(_vm._s(_vm.categoryToKoreaLang[_vm.editCategory]) + " 사전 등록/수정 요청")]), _c('button', {
    staticClass: "pop_close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("닫기")])]), _vm.getIsSameDictionary ? _c('div', {
    staticClass: "pop_cont"
  }, [_c('ul', [_c('li', [_c('h3', {
    staticClass: "form_tit"
  }, [_vm._v(_vm._s(`사전 정보`))]), _c('table', {
    staticClass: "tbl_style2"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.defaultData.displayTagName))])]), _c('tbody', [_c('tr', {
    staticClass: "selected"
  }, [_c('td', {
    staticClass: "text-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.defaultData.displayTagName))])])])])])])])]) : _c('div', {
    staticClass: "pop_cont"
  }, [_c('h3', {
    staticClass: "form_tit"
  }, [_vm._v(" 유사어 등록 설명 ")]), _c('span', [_vm._v("    * 좌측 = 연결하려는 상대의 정보, 우측 = 현재 수정 중인 정보입니다. ")]), _c('br'), _c('span', [_vm._v("    * 좌측을 공정도A, 우측을 프로토콜B 라고 가정 시 화살표를 클릭하면 아래와 같이 동작하게 됩니다. ")]), _c('br'), _vm._m(0), _c('br'), _vm._m(1), _c('br'), _c('br'), _vm._m(2), _c('br'), _c('ul', {
    staticClass: "column col_2"
  }, [_c('li', [_c('h3', {
    staticClass: "form_tit"
  }, [_vm._v(_vm._s(`${_vm.targetDictionary.target}`))]), _c('table', {
    staticClass: "tbl_style2"
  }, [_vm._m(3), _c('thead', [_c('tr', [((_vm$targetDictionary$ = _vm.targetDictionary.displayTagList) === null || _vm$targetDictionary$ === void 0 ? void 0 : _vm$targetDictionary$.length) > 0 ? _c('th', [_vm._v(" " + _vm._s(_vm.targetDictionary.displayTagList[0].displayTagName) + " ")]) : _vm._e()])]), _c('tbody', _vm._l(_vm.targetDictionary.displayTagList, function (row, index) {
    return _c('tr', {
      key: index,
      class: {
        selected: index == 0
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('span', [_vm._v(_vm._s(row.displayTagName))])])]);
  }), 0)])]), _c('li', [_c('h3', {
    staticClass: "form_tit"
  }, [_vm._v(_vm._s(`${_vm.correctionTargetDictionary.target}`))]), _c('table', {
    staticClass: "tbl_style2"
  }, [_vm._m(4), _c('thead', [_c('tr', [((_vm$correctionTargetD = _vm.correctionTargetDictionary.displayTagList) === null || _vm$correctionTargetD === void 0 ? void 0 : _vm$correctionTargetD.length) > 0 ? _c('th', [_vm._v(" " + _vm._s(_vm.correctionTargetDictionary.displayTagList[0].displayTagName) + " ")]) : _vm._e()])]), _c('tbody', _vm._l(_vm.correctionTargetDictionary.displayTagList, function (row, index) {
    return _c('tr', {
      key: index,
      class: {
        selected: index == 0
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('span', [_vm._v(_vm._s(row.displayTagName))])])]);
  }), 0)])])])]), !_vm.getIsSameDictionary ? _c('div', {
    staticClass: "pop_foot"
  }, [_c('button', {
    staticClass: "pop_btn icon-arrow-right",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.leftToRight
    }
  }), _c('button', {
    staticClass: "pop_btn icon-arrow-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rightToLeft
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "pop_foot"
  }, [_vm.editFlag ? _c('button', {
    staticClass: "pop_btn type2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveDictionary
    }
  }, [_vm._v("저장")]) : _vm._e(), _c('button', {
    staticClass: "pop_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("닫기")])])]), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("    * 좌측 화살표를 클릭하면 공정도A에서 현재 사용 중인 표시어를 프로토콜B에 유사어로 추가하게 됩니다. "), _c('br'), _vm._v("      프로토콜B의 경우 현재 수정 중인 정보이기 때문에 방금 추가한 유사어로 프로토콜B의 표시어도 변경할지 물어보게 됩니다. ")]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("    * 우측 화살표를 클릭하면 프로토콜B에서 현재 사용 중인 표시어를 공정도A에 유사어로 추가하게 됩니다. "), _c('br'), _vm._v("      공정도A의 경우 연결하려는 상대의 정보이고 B프로토콜에서 사용 중인 사전은 수정되지 않았기 때문에 표시어 변경을 물어보는 확인창이 나타나지 않습니다. ")]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v("    * ex ) 공정도C(좌)에 프로토콜D(우)를 연결하는 과정에서 장비 정보가 상이하여 연결이 불가능한 경우. "), _c('br'), _vm._v("      (공정도C에서 사용 중인 장비는 XPS (UPS, IPES), 프로토콜D에서 사용 중인 장비는 XPS) "), _c('br'), _vm._v("      좌측 화살표 클릭 후 저장 : 프로토콜D에서 사용 중인 사전에 XPS (UPS, IPES)를 유사어로 추가하게 되며, "), _c('br'), _vm._v("                                               프로토콜D는 표시어를 XPS (UPS, IPES)로 변경 또는 XPS로 유지할 수 있습니다. "), _c('br'), _vm._v("      우측 화살표 클릭 후 저장 : 공정도C에서 사용 중인 사전에 XPS를 유사어로 추가하게 되며, "), _c('br'), _vm._v("                                               프로토콜D에서 사용 중인 사전은 수정되지 않았기에 표시어가 XPS로 유지되게 됩니다. ")]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "70%"
    }
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "70%"
    }
  })]);

}]

export { render, staticRenderFns }